import React, { Component } from "react";

import { Link} from "react-router-dom";

import { JENIS_DESA } from "../../../function/Koneksi";

// Import custom components
// import UserPanel from "./user-panel.component";

// koneksi
// import { STATUS_LAYANAN_KUA, STATUS_LAYANAN_CAPIL, GetMarketplace, ID_DESA } from "../../../function/Koneksi";

class SidebarAdminWebsite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paid: this.props.paid,
      lisensi: this.props.lisensi,
    };
  }

  cekStatus(){
    if (this.state.lisensi == null || this.state.paid == null) {
      return '/admin/layanan/join-us'
    } else if (this.state.paid && this.state.lisensi) {
      return true
    } else if (this.state.paid && this.state.lisensi == false) {
      return '/admin/layanan/expired'
    }
  }

  render() {
    return (
      <div className="bayu-sidebar custom-scrollbar bayu-sidebar-open">
        <ul className="sidebar-menu">
          <div className="dropdown-basic">
            <div className="row">
              <div className="dropdown">
                <Link to={process.env.PUBLIC_URL}>
                  <div className="btn-group m-1">
                    <button
                      type="button"
                      className="dropbtn btn-primary-custom"
                      style={{ borderRadius: "10px", width: "155px" }}
                    >
                      <i className="fa fa-home"></i> Dashboard
                    </button>
                  </div>
                </Link>
              </div>
              <div className="dropdown">
                <Link to={process.env.PUBLIC_URL + "/admin-web/profile-" + JENIS_DESA.toLowerCase()}>
                  <div className="btn-group m-1">
                    <button
                      type="button"
                      className="dropbtn btn-primary-custom"
                      style={{ borderRadius: "10px", width: "155px" }}
                    >
                      <i className="fa fa-building"></i> Profil {JENIS_DESA}
                    </button>
                  </div>
                </Link>
              </div>
              <div className="dropdown">
                <Link to={process.env.PUBLIC_URL + "/admin-web/lembaga-masyarakat"}>
                  <div className="btn-group m-1">
                    <button
                      type="button"
                      className="dropbtn btn-primary-custom"
                      style={{ borderRadius: "10px", width: "155px" }}
                    >
                      <i className="icofont icofont-building"></i> Kelembagaan
                    </button>
                  </div>
                </Link>
              </div>
              <div className="dropdown">
                <Link to={process.env.PUBLIC_URL + "/admin-web/wisata"}>
                  <div className="btn-group m-1">
                    <button
                      type="button"
                      className="dropbtn btn-primary-custom"
                      style={{ borderRadius: "10px", width: "155px" }}
                    >
                      <i className="fa fa-map"></i> Wisata {JENIS_DESA}
                    </button>
                  </div>
                </Link>
              </div>
              <div className="dropdown">
                <div className="btn-group m-1">
                  <button
                    type="button"
                    className="dropbtn btn-primary-custom"
                    style={{ borderRadius: "10px", width: "155px" }}
                  >
                    <i className="icofont icofont-ui-note"></i> Informasi {JENIS_DESA}
                    <span>
                      <i className="icofont icofont-arrow-down"></i>
                    </span>
                  </button>
                  <div className="dropdown-content">
                    <div className="liyu2">
                      <a >
                        <i className="fa fa-money"></i> Bantuan Sosial
                        <span style={{ float: "right" }}>
                          <i className="fa fa-angle-right"></i>
                        </span>
                      </a>
                      <div className="liyu3">
                        <Link
                          to={
                            this.cekStatus ? "/admin-web/bansos/master-kategori-bansos" : this.cekStatus
                          }
                        >
                          <i className="fa fa-database"></i> Data Kategori Bansos
                        </Link>
                        <Link
                          to={
                            this.cekStatus ? "/admin-web/bansos/master-bansos" : this.cekStatus
                          }
                        >
                          <i className="fa fa-database"></i> Data Bansos
                        </Link>
                        <Link
                          to={
                            this.cekStatus ? "/admin-web/bansos/statistik" : this.cekStatus
                          }
                        >
                          <i className="fa fa-database"></i> Data Statistik
                        </Link>
                      </div>
                    </div>
                    <Link to={ 
                      this.cekStatus ? "/admin-web/berita" : this.cekStatus
                      }>
                      <i className="icon-rss-alt"></i> Berita & Pengumuman
                    </Link>
                    <Link to={ 
                      this.cekStatus ? "/admin-web/info-anggaran" : this.cekStatus
                      }>
                      <i className="icofont icofont-ui-note"></i> Informasi Anggaran
                    </Link>
                    <Link to={ 
                      this.cekStatus ? "/admin-web/info-ppid" : this.cekStatus
                      }>
                      <i className="icofont icofont-ui-note"></i> Informasi PPID
                    </Link>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </ul>
      </div>
    );
  }
}

export default SidebarAdminWebsite;
